import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Species } from '../../core/models/species.model';

export const loadSpeciess = createAction(
  '[Species] Load Speciess',
  props<{ speciess: Species[] }>()
);

export const addSpecies = createAction(
  '[Species] Add Species',
  props<{ species: Species }>()
);

export const upsertSpecies = createAction(
  '[Species] Upsert Species',
  props<{ species: Species }>()
);

export const addSpeciess = createAction(
  '[Species] Add Speciess',
  props<{ speciess: Species[] }>()
);

export const upsertSpeciess = createAction(
  '[Species] Upsert Speciess',
  props<{ speciess: Species[] }>()
);

export const updateSpecies = createAction(
  '[Species] Update Species',
  props<{ species: Update<Species> }>()
);

export const updateSpeciess = createAction(
  '[Species] Update Speciess',
  props<{ speciess: Update<Species>[] }>()
);

export const deleteSpecies = createAction(
  '[Species] Delete Species',
  props<{ id: string }>()
);

export const deleteSpeciess = createAction(
  '[Species] Delete Speciess',
  props<{ ids: string[] }>()
);

export const clearSpeciess = createAction(
  '[Species] Clear Speciess'
);
